/* eslint-disable no-empty-pattern */
import {call, put, delay} from 'redux-saga/effects'
import {push} from 'connected-react-router'
import AdvertisersActions from '../Redux/AdvertisersRedux'
import AuthActions from '../Redux/AuthRedux'
import ErrorsActions from '../Redux/ErrorsRedux'

// const fakeData = {
//   next: null,
//   results: [
//     {
//       icon:
//         'https://scontent-lax3-2.xx.fbcdn.net/v/t1.0-1/p100x100/58733016_2723243737748228_7750458688258703360_n.jpg?_nc_cat=111&ccb=2&_nc_sid=b2f0f4&_nc_ohc=D9zs3YxNZJoAX9vr1J8&_nc_ht=scontent-lax3-2.xx&tp=6&oh=19250566f13885cc9fe349f99c4eda4b&oe=5FCE40F4',
//       id: '317876071618352',
//       is_deleted: false,
//       is_following: false,
//       is_verified: false,
//       username: 'Hotel Margaréta Balatonfüred',
//     },
//     {
//       icon:
//         'https://scontent-lax3-2.xx.fbcdn.net/v/t1.0-1/p100x100/27657916_1595851703828321_5999643188059316234_n.jpg?_nc_cat=111&ccb=2&_nc_sid=b2f0f4&_nc_ohc=uV00MDGTonYAX8UfbW8&_nc_ht=scontent-lax3-2.xx&tp=6&oh=d5c2ff9b8f35312c622e8eef58c91021&oe=5FCBBB73',
//       id: '847649488648550',
//       is_deleted: true,
//       is_following: false,
//       is_verified: false,
//       username: 'Chalantika-চলন্তিকা',
//     },
//     {
//       icon:
//         'https://scontent-lax3-1.xx.fbcdn.net/v/t1.0-1/p100x100/109119277_306065740760375_8977408574545050823_n.jpg?_nc_cat=104&ccb=2&_nc_sid=b2f0f4&_nc_ohc=pzt1gWefA4wAX9rbTkE&_nc_ht=scontent-lax3-1.xx&tp=6&oh=962279fe1dd41f660dac506e5ce9b612&oe=5FBD78C5',
//       id: '110873070279644',
//       is_deleted: true,
//       is_following: false,
//       is_verified: false,
//       username: 'Azattyq Ruhy',
//     },
//     {
//       icon:
//         'https://scontent-fml2-1.xx.fbcdn.net/v/t1.0-1/p100x100/46145_129027070476507_6267360_n.jpg?_nc_cat=103&ccb=2&_nc_sid=b2f0f4&_nc_ohc=wMSI8gI5t-kAX_quQQP&_nc_ht=scontent-fml2-1.xx&tp=6&oh=f1343a6f4e7524a74997dde1dac9adaa&oe=5FCEB76D',
//       id: '122010754511472',
//       is_deleted: true,
//       is_following: false,
//       is_verified: false,
//       username: 'A. Ally & Sons',
//     },
//     {
//       icon:
//         'https://scontent-lax3-1.xx.fbcdn.net/v/t1.0-1/p100x100/11351306_1120308907995934_4827357269731548960_n.jpg?_nc_cat=108&ccb=2&_nc_sid=b2f0f4&_nc_ohc=k0aS4ufoF8YAX9sdSmg&_nc_ht=scontent-lax3-1.xx&tp=6&oh=d448041f3b8e94181bafaf5cc5651c46&oe=5FCAB99C',
//       id: '817639178262910',
//       is_deleted: true,
//       is_following: false,
//       is_verified: false,
//       username: 'Agami Realty',
//     },
//     {
//       icon:
//         'https://scontent-fml2-1.xx.fbcdn.net/v/t1.0-1/p100x100/123770559_2838341856268252_6390688351161229995_n.jpg?_nc_cat=101&ccb=2&_nc_sid=b2f0f4&_nc_ohc=Q7OagxULTHMAX96B22x&_nc_ht=scontent-fml2-1.xx&tp=6&oh=1d776a1abbd5695b15a9e3a6a774f42b&oe=5FCBF638',
//       id: '544398905662570',
//       is_deleted: true,
//       is_following: false,
//       is_verified: false,
//       username: "Pretty'n'Perfect Vintage Collectibles",
//     },
//     {
//       icon:
//         'https://scontent-bos3-1.xx.fbcdn.net/v/t1.0-1/p100x100/118487253_116853613475956_958892727073108397_n.jpg?_nc_cat=1&ccb=2&_nc_sid=b2f0f4&_nc_ohc=qDjNRsJDVzYAX9Hva0B&_nc_ht=scontent-bos3-1.xx&tp=6&oh=b4cc2e7133a1600d7938790b3362ca42&oe=5FCE024C',
//       id: '111668257327825',
//       is_deleted: true,
//       is_following: false,
//       is_verified: false,
//       username: 'มะม่วงหิมพานต์ราคาส่ง',
//     },
//     {
//       icon:
//         'https://scontent-bos3-1.xx.fbcdn.net/v/t1.0-1/p100x100/36121364_1199595980180462_5356931705494044672_o.png?_nc_cat=1&ccb=2&_nc_sid=b2f0f4&_nc_ohc=CoDJ2zd-r_QAX-jxueO&_nc_ht=scontent-bos3-1.xx&oh=d05791211cdfd783095fef5155551353&oe=5FCD2943',
//       id: '445164788956922',
//       is_deleted: true,
//       is_following: false,
//       is_verified: true,
//       username: 'PopDaily 波波黛莉的異想世界',
//     },
//     {
//       icon:
//         'https://scontent-lga3-2.xx.fbcdn.net/v/t1.0-1/p100x100/57024044_2655874111153695_6914251516622667776_n.png?_nc_cat=1&ccb=2&_nc_sid=b2f0f4&_nc_ohc=TO5XOLcUTC8AX_J2HJH&_nc_ht=scontent-lga3-2.xx&oh=a880541e5f30c7d29829056f613400fd&oe=5FCDEE7A',
//       id: '831443753596749',
//       is_deleted: true,
//       is_following: false,
//       is_verified: false,
//       username: 'Vavato',
//     },
//     {
//       icon:
//         'https://scontent-bos3-1.xx.fbcdn.net/v/t1.0-1/p100x100/83229030_1594741440690029_4033648776903131136_o.png?_nc_cat=106&ccb=2&_nc_sid=b2f0f4&_nc_ohc=iem-bm0XNjUAX8Tz7Qn&_nc_ht=scontent-bos3-1.xx&oh=b2aaab3a7d4f406ebd32e30155fd753d&oe=5FCD4C7C',
//       id: '172398386257682',
//       is_deleted: true,
//       is_following: false,
//       is_verified: null,
//       username: 'BePlus Baby',
//     },
//     {
//       icon:
//         'https://scontent-bos3-1.xx.fbcdn.net/v/t1.0-1/p100x100/46508722_10157041512489824_2628790705530601472_n.png?_nc_cat=100&ccb=2&_nc_sid=b2f0f4&_nc_ohc=JkJwFxyR0uMAX9xRaum&_nc_ht=scontent-bos3-1.xx&oh=5c90863f4ffaa547f300491b622de033&oe=5FCE6BEA',
//       id: '154800724823',
//       is_deleted: true,
//       is_following: false,
//       is_verified: false,
//       username: 'Holiday Snacks',
//     },
//     {
//       icon:
//         'https://scontent-lax3-1.xx.fbcdn.net/v/t1.0-1/p100x100/18671099_1369902336389278_8561133192995555156_n.png?_nc_cat=102&ccb=2&_nc_sid=b2f0f4&_nc_ohc=MBFEWgA-fO0AX9Tr7QJ&_nc_ht=scontent-lax3-1.xx&oh=53240ddc6fe523c29ad86d562ebeb226&oe=5FCC739A',
//       id: '149795705066620',
//       is_deleted: true,
//       is_following: false,
//       is_verified: false,
//       username: 'Apetit',
//     },
//   ],
// }

export function* getFollowingsAdvertisers(api, authApi, {}) {
  try {
    const response = yield call(api.getFollowingsAdvertisers)
    if (response && response.ok) {
      yield put(AdvertisersActions.followingsAdvertisersSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(AdvertisersActions.advertisersFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getFollowingsAdvertisers(api, authApi, {})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(AdvertisersActions.advertisersFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getAdvertiser(api, authApi, {id}) {
  try {
    const response = yield call(api.getAdvertiser, id)
    if (response && response.ok) {
      yield put(AdvertisersActions.advertiserSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(AdvertisersActions.advertisersFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getAdvertiser(api, authApi, {id})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(AdvertisersActions.advertisersFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* deleteRestoreAdvertiser(api, authApi, {id, data}) {
  try {
    yield delay(2000)
    yield put(AdvertisersActions.deleteRestoreAdvertiserSuccess(true, id))

    // const response = yield call(api.deleteRestoreAdvertiser, id, data)
    // if (response && response.ok) {
    //   yield put(AdvertisersActions.deleteRestoreAdvertiserSuccess(response.data))
    // } else {
    //   if (response && response.data) {
    //     if (response.status === 401) {
    //       yield put(ErrorsActions.errorSave(null))
    //     } else if (response.status === 500) {
    //       yield put(ErrorsActions.errorSave('Server response error'))
    //     } else {
    //       yield put(ErrorsActions.errorSave(response.data))
    //     }
    //   } else {
    //     yield put(ErrorsActions.errorSave('Server response error'))
    //   }
    //   yield put(AdvertisersActions.advertisersFetchingReset())
    // }

    // if (response && response.status === 401) {
    //   const res = yield call(authApi.tokenRefresh)
    //   if (res && res.access) {
    //     yield put(AuthActions.updateTokens(res.access, res.refresh))
    //     yield* deleteRestoreAdvertiser(api, authApi, {id, data})
    //   } else {
    //     yield put(AuthActions.logout())
    //     yield put(push('/login'))
    //   }
    // }
  } catch (e) {
    yield put(AdvertisersActions.advertisersFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getAdvertisers(api, authApi, {filter}) {
  try {
    // yield delay(2000)
    // yield put(AdvertisersActions.advertisersSuccess(fakeData))

    const response = yield call(api.getAdvertisers, filter)
    if (response && response.ok) {
      yield put(AdvertisersActions.advertisersSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(AdvertisersActions.advertisersFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getAdvertisers(api, authApi, {filter})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(AdvertisersActions.advertisersFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}
